import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { services } from '@services/api'
import { Collapse, Icon, Popconfirm, Button } from 'antd'
import Service from './Service'
import AddNewService from './AddNewService'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.refreshServiceList = this.refreshServiceList.bind(this)
        this.state = {
            servicesArr: []
        }
    }

    componentDidMount() {
        this.refreshServiceList()
    }
    refreshServiceList() {
        services.servicesList().then(res => this.setState({ servicesArr: res.data }))
    }
    render() {
        const { servicesArr } = this.state
        const { Panel } = Collapse
        const getFreezeIcon = (id, active) => (
            <Popconfirm
                title={`האם אתה בטוח שברצונך ${active ? 'להקפיא' : 'לבטל הקפאת'} שירות זה?`}
                okText="אני בטוח/ה"
                cancelText="ביטול"
                onConfirm={async event => {
                    event.stopPropagation()
                    event.preventDefault()
                    await services.handleFreezeServie(id, +!active)
                    this.refreshServiceList()
                }}
            >
                <Button
                    onClick={event => {
                        event.stopPropagation()
                        event.preventDefault()
                    }}
                >
                    <Icon type={active ? 'lock' : 'unlock'} />
                </Button>
            </Popconfirm>
        )
        return servicesArr.length ? (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                {servicesArr.map(serv => (
                    <Panel
                        header={'מזהה: ' + serv.id + ', ' + serv.name}
                        key={serv.id}
                        style={{ textDecoration: !!serv.active ? undefined : 'line-through' }}
                        disabled={!serv.active}
                        extra={getFreezeIcon(serv.id, !!serv.active)}
                    >
                        <Service service={serv} refreshServiceList={this.refreshServiceList} />
                    </Panel>
                ))}
                <Panel header={'הוסף שירות חדש'} key={servicesArr.length + 1}>
                    <AddNewService refreshServiceList={this.refreshServiceList} />
                </Panel>
            </Collapse>
        ) : (
            <Icon type="loading" />
        )
    }
}
